import Handlebars from "handlebars/dist/handlebars.js";

var createstaticlink = (function () {
    "use strict";

    if ($(".createstaticlink").length > 0) {

        $("body").on("click", "#generate-staticlink", generateStaticLink);
        $("body").on("click", "#generate-subscriptionlink", generateSubscriptionLink);

        $("body").on("keydown", function (e) {
            if (e.keyCode === 13) {
                return false;
            }
        });

    }

    function addUrlParam(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + value + "$2");
        } else {
            return uri + separator + key + "=" + value;
        }
    }

    function generateSubscriptionLink(e) {
        e.preventDefault();

        var $this = $(this),
            $staticlink = $("#generate-subscriptionlink"),
            source = $("#subscriptionlink-template").html(),
            template = Handlebars.compile(source),
            errorMessage = $staticlink.attr("data-error-message"),
            link = $staticlink.attr("data-staticlink"),
            subscription = JSON.parse($staticlink.attr("data-subscription").replace(/'/ig, "\"")),
            links = [];

        var associationId = $("#association-id").val();

        $.each(subscription, function () {
            var link = addUrlParam(this.url, "a", associationId);
            if (this.code !== "") {
                link = addUrlParam(link, "kampanj", this.code);
            }

            links.push({
                Link: link,
                LinkUrlEncoded: encodeURIComponent(link),
                Headline: this.text
            });
        });

        if (associationId === "" || associationId === undefined) {
            createErrorMessage("Var god välj en förening.");
        } else {
            Utils.TrackGoogleEvent("ForeningslankPrenumeration", "Skapa", links.map((x) => x.Link).join(", "));

            var html = template({
                Links: links
            });
            $(".modal").append(html);
            $(".modal .banner-code textarea").select();
        }
    }

    function generateStaticLink(e) {
        e.preventDefault();

        var $this = $(this),
            $staticlink = $("#generate-staticlink"),
            createstaticlink = $this.closest(".createstaticlink"),
            source = $("#staticlink-template").html(),
            template = Handlebars.compile(source),
            errorMessage = $staticlink.attr("data-error-message"),
            link = $staticlink.attr("data-staticlink");

        var associationId = $("#association-id").val();

        if (associationId === "" || associationId === undefined) {
            createErrorMessage("Var god välj en förening.");
        }
        else {
            var html = template({
                Link: addUrlParam(link, "a", associationId),
                LinkUrlEncoded: encodeURIComponent(addUrlParam(link, "a", associationId))
            });
            $(".modal").append(html);
            $(".modal .banner-code textarea").select();
        }
        function failHandler(err) {
            createErrorMessage(SETTINGS.exceptions.generic);
        };
    }

    function createErrorMessage(errorMessage) {
        var source = $("#staticlink-error-template").html(),
            template = Handlebars.compile(source),
            data = {
                "Message": new Handlebars.SafeString(errorMessage)
            };
        var html = template(data);
        $(".modal").empty().append(html);
    }

})();